<template>
  <v-container class="pa-10" fluid>
    <v-row class="mb-7" justify="center">
      <h1>Meta-Credentials</h1>
    </v-row>
    <v-row align="center" justify="center">
      <v-col class="d-flex align-center justify-center" cols="12" sm="12" md="5" lg="5" xl="5">
        <v-text-field :disabled="loadingCredentials" prepend-icon="fa-search"
                      placeholder="Search by login, user id or user first name..." v-model="search"/>
        <v-btn :disabled="loadingCredentials" class="ml-3" @click="exportCSV">Export to CSV<v-icon class="ml-2" small>fa-share</v-icon></v-btn>
      </v-col>
    </v-row>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" md="12" lg="10" xl="10">
        <v-data-table :items="metaCredentials" :headers="headers" :loading="loadingCredentials" :search="search">
          <template v-slot:item.brokerAccount.user.firstName="{ item }">
            <p class="my-0">{{ item.brokerAccount.user.firstName }} {{ item.brokerAccount.user.lastName }}</p>
          </template>
          <template v-slot:item.version="{ item }">
            <v-chip :color="(item.version === 'MT4')? '#0C4F41' : '#670CF2'"><p style="color: #FFFFFF" class="my-0">{{ item.version }}</p></v-chip>
          </template>
          <template v-slot:item.brokerAccount.lastActivity="{ item }">
            <p class="my-0">{{ (item.brokerAccount.lastActivity !== null)? String(item.brokerAccount.lastActivity).replaceAll('T', ' ').replaceAll('Z', '') : 'No activity registered' }}</p>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Repository from '../../repositories/metaCredentials';

export default {
  name: "MetaCredentials",
  data() {
    return {
      search: '',
      loadingCredentials: false,
      metaCredentials: [],
      headers: [
        { text: 'User ID', value: 'brokerAccount.user.id', sortable: true, filterable: true },
        { text: 'User Full Name', value: 'brokerAccount.user.firstName', sortable: true, filterable: true },
        { text: 'Account', value: 'brokerAccount.identifier', sortable: false, filterable: true },
        { text: 'Version', value: 'version', sortable: true, filterable: false },
        { text: 'Server', value: 'server', sortable: true, filterable: true },
        { text: 'Login', value: 'login', sortable: false, filterable: true },
        { text: 'Investor Password', value: 'password', sortable: false, filterable: false },
        { text: 'Last Activity', value: 'brokerAccount.lastActivity', sortable: true, filterable: true },
      ]
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loadingCredentials = true;
      Repository.allMetaCredentials().then((response) => {
        if(response.status < 400) {
          this.metaCredentials = response.data;
          this.loadingCredentials = false;
        }
      });
    },
    exportCSV() {
      let rows = [['User ID', 'User Full Name', 'Account', 'Version', 'Server', 'Login', 'Investor Password', 'Last Activity'],];

      this.metaCredentials.forEach((metaCredential) => {
        rows.push([
          `${metaCredential.brokerAccount.user.id}`,
          `${metaCredential.brokerAccount.user.firstName}`,
          `${metaCredential.brokerAccount.identifier}`,
          `${metaCredential.version}`,
          `${metaCredential.server}`,
          `${metaCredential.login}`,
          `${metaCredential.password.replaceAll('#', '%23')}`,
          `${(metaCredential.brokerAccount.lastActivity !== null) ? metaCredential.brokerAccount.lastActivity : 'No activity registered'}`,
        ]);
      });
      let csvContent = "data:text/csv;charset=utf-8," + rows.map(e => e.join(",")).join("\n");

      // Encoding and data downloading
      let encodedUri = encodeURI(csvContent);
      let link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "Swiset Meta-Credentials.csv");
      document.body.appendChild(link);
      link.click();
      alert(`Successfully exported data with ${rows.length} rows on file.\nAll # where changed to %23.⚠️`);
    },
  }
}
</script>

<style scoped>

</style>
